import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
export function useAllPropertiesPanelDeepLink(subjectId, objectTypeId) {
  const history = useHistory();
  const location = useLocation();
  const sendCrmMessage = useSendCrmMessageTopic('OPEN_ALL_PROPERTIES_PANEL');
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('shouldOpenAllPropertiesPanel')) {
      const messageData = {
        objectId: subjectId,
        objectTypeId,
        initialSearchTerm: searchParams.get('shouldOpenAllPropertiesPanel') || ''
      };
      sendCrmMessage(messageData);
      searchParams.delete('shouldOpenAllPropertiesPanel');
      history.replace(Object.assign({}, location, {
        search: searchParams.toString()
      }));
    }
  }, [sendCrmMessage, history, location, subjectId, objectTypeId]);
}